<template>
  <div>
    <c-list
      :data="cList.items"
      :columns="cList.columns"
      :total="cList.total"
      :page-size="1000"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button @click="$helpers.goBack()">返回</Button>
        </c-list-operations>
      </c-list-header>
    </c-list>
    <c-class-hours-form
      ref="classHoursForm"
      @get-list="getList"
    ></c-class-hours-form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";
import Model from "@/models/admin/courses";
import ClassHoursForm from "./class-hours-form";

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    "c-class-hours-form": ClassHoursForm
  }
})
export default class extends Vue {
  data() {
    const { ListColumnWidth } = this.$consts;

    return {
      cList: {
        items: [],
        total: 0,
        columns: [
          {
            title: "班级",
            render: (h, { row }) => h("span", null, row.className)
          },
          {
            title: "教师",
            width: 120,
            render: (h, { row }) => h("span", null, row.classTeacherName)
          },
          {
            title: "学员",
            width: 120,
            render: (h, { row }) => h("span", null, row.signIn.student.name)
          },
          {
            title: "正常",
            width: 70,
            key: "normalCount",
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.signIn.type === "Normal"
                  ? [
                      h(
                        "Icon",
                        {
                          attrs: { style: "font-size: 18px; color: green;" },
                          props: {
                            type: "md-checkmark-circle"
                          }
                        },
                        ""
                      )
                    ]
                  : ""
              )
          },
          {
            title: "迟到",
            width: 70,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.signIn.type === "Late"
                  ? [
                      h(
                        "Icon",
                        {
                          attrs: { style: "font-size: 18px; color: green;" },
                          props: {
                            type: "md-checkmark-circle"
                          }
                        },
                        ""
                      )
                    ]
                  : ""
              )
          },
          {
            title: "请假",
            width: 70,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.signIn.type === "Leave"
                  ? [
                      h(
                        "Icon",
                        {
                          attrs: { style: "font-size: 18px; color: green;" },
                          props: {
                            type: "md-checkmark-circle"
                          }
                        },
                        ""
                      )
                    ]
                  : ""
              )
          },
          {
            title: "总课时",
            width: 100,
            render: (h, { row }) =>
              h("span", null, row.signIn.student.classHours)
          },
          {
            title: "已用课时",
            width: 100,
            render: (h, { row }) =>
              h("span", null, row.signIn.student.usedClassHours)
          },
          {
            title: "剩余课时",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.signIn.student.classHours -
                  row.signIn.student.usedClassHours
              )
          },
          {
            title: "时间",
            width: ListColumnWidth.CreatedAt,
            render: (h, { row }) => h("span", this.$time.getTime(row.updatedAt))
          },
          {
            title: "操作",
            key: "action",
            width: 192,
            render: (h, { row }) =>
              h("div", [
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.$refs.classHoursForm.show(row);
                      }
                    }
                  },
                  "设置课时"
                ),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row);
                    }
                  }
                })
              ])
          }
        ]
      }
    };
  }

  async created() {
    await this.getList();
  }

  async getList() {
    const {
      data: { items, total }
    } = await new Model().addPath("getStudentSignIns").POST({
      body: {
        studentId: this.$route.params.studentId
      }
    });

    this.cList.items = items;
    this.cList.total = total;
  }

  async confirmDelete(row) {
    const {
      signIn: {
        student: { id: studentId }
      },
      courseId
    } = row;

    await this.$store.dispatch("courses/postAction", {
      action: "deleteSignIn",
      body: { courseId, studentId }
    });

    this.$Message.success("删除成功");
    this.getList();
  }
}
</script>
